import { useEffect } from 'react';
import { Platform } from 'react-native';

export interface SubmitShortcutOptions {
	enabled: boolean;
	onSubmit: () => void;
}

/**
 * Fires `onSubmit` on Cmd+Enter (Mac) / Alt+Enter / Ctrl+Enter. Web-only —
 * native has no equivalent modifier convention worth mimicking.
 */
export function useSubmitShortcut({ enabled, onSubmit }: SubmitShortcutOptions): void {
	useEffect(() => {
		if (!enabled) return;
		if (Platform.OS !== 'web') return;
		if (typeof window === 'undefined') return;

		const handler = (event: KeyboardEvent) => {
			if (event.key !== 'Enter') return;
			if (!(event.metaKey || event.altKey || event.ctrlKey)) return;
			// Don't submit mid-IME composition (Japanese/Chinese input).
			if (event.isComposing) return;
			event.preventDefault();
			event.stopPropagation();
			onSubmit();
		};

		window.addEventListener('keydown', handler);
		return () => window.removeEventListener('keydown', handler);
	}, [enabled, onSubmit]);
}
